import React, { useState, useEffect } from "react";
import CoinCard from "../components/CoinCard";
const Bookmarked = () => {
  const [bookmarkedCoins, setBookmarkedCoins] = useState([]);

  useEffect(() => {
    // Retrieve all bookmarked coins from local storage
    const coins = Object.keys(localStorage)
      .filter((key) => key.startsWith("bookmark_"))
      .map((key) => JSON.parse(localStorage.getItem(key)));
    setBookmarkedCoins(coins);
  }, []);

  return (
    <div className="container">
      <p className="mx-2 my-12 uppercase font-black text-transparent animate-text bg-gradient-to-r from-blue-500 via-cyan-500 to-violet-500 bg-clip-text text-2xl">
        Bookmarked Coins
      </p>
      <div className=" mx-auto mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {bookmarkedCoins.map((coin) => (
          <div key={coin.id} className="p-4 mb-4">
            <CoinCard coin={coin} />
          </div>
        ))}
      </div>{" "}
    </div>
  );
};

export default Bookmarked;
